import { render, staticRenderFns } from "./DebtorListItem.vue?vue&type=template&id=ca040d28&scoped=true"
import script from "./DebtorListItem.vue?vue&type=script&lang=js"
export * from "./DebtorListItem.vue?vue&type=script&lang=js"
import style0 from "./DebtorListItem.vue?vue&type=style&index=0&id=ca040d28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca040d28",
  null
  
)

export default component.exports